import React from "react";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* About */}
        <div className="footer-section">
          <h3>منصة تفوَّق التعليمية</h3>
          <p>
            منصة تعليمية سهلة, سريعة, بسيطة
            تسهل العملية التعليمية للطلاب, وإدارة المحتوى للمعلمين
          </p>
        </div>

        {/* Links */}
        <div className="footer-section">
          <h3>روابط سريعة</h3>
          <ul>
            <li><a href="/">الرئيسية</a></li>
            <li><a href="/services">من نحن</a></li>
            <li><a href="/contact-us">تواصل معنا</a></li>
            <li><a href="/privacy-policy">سياسة الخصوصية</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h3>للتواصل</h3>
          <p>Email: oppadnasser@gmail.com</p>
          <p>Phone: +20 155 686 8406</p>
        </div>

      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} منصة تفوَّق التعليمة. جميع الحقوق محفوظة .
      </div>
    </footer>
  );
};

export default Footer;
